import React from 'react'
import qs from 'qs'
import { initializeFormValidation } from '../../../../helpers/forms/form-validation'
import customRequest from '../../../../helpers/customRequest'
import redirect from '../../../../components/redirect/redirect'
import message from '../../../../components/message/message'
import ClipLoader from 'react-spinners/ClipLoader'

class Remove extends React.Component
{
    state = 
    {
        customer : null,
        student : null,
        submitting: false
    }
    componentDidMount() {
        var params = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
        this.setState({customer: params.customer, student: params.student})

        initializeFormValidation(this.onSubmit)
    }

    onSubmit = () => {
        this.setState({ submitting: true }, () => {
            customRequest.delete('/api/students/share', {data: {
                customerUsername: this.state.customer,
                studentName: this.state.student
            }})
            .then(({data: response}) => {
                redirect.send('/students', () => {
                    if (response.valid) {
                        message.success('You have successfully removed your permissions on the student shared to you.')
                    } else {
                        message.success(response.message)
                    }
                })
            })
        })
    }

    render()
    {
        var {student, customer} = this.state
        return (
        <React.Fragment>
            <h1>Remove Shared Student</h1>
            <form class = "form-horizontal prevent-next-submit form-validate" noValidate method = "post">
                <div class = "form-group row">
                    <label class = "d-none d-sm-inline col-sm-6 control-label text-right">Sharing User</label>
                    
                    <div class = "col-sm-6">
                        <p class = "form-control-static text-left text-center-xs break-words">{customer}</p>
                    </div>
                </div>
                
                <div class = "form-group row">
                    <label class = "d-none d-sm-inline col-sm-6 control-label text-right">Student Name</label>
                    
                    <div class = "col-sm-6">
                        <p class = "form-control-static text-left text-center-xs break-words">{student}</p>
                    </div>
                </div>
                
                <button type = "submit" disabled={this.state.submitting} class = "btn btn-secondary btn-lg">
                {this.state.submitting ?
                    <ClipLoader
							size={20}
							color={"#123abc"}
							loading={this.state.submitting}
							/> : "Remove"
                }</button>
            </form>
        </React.Fragment>)
    }
}

export default Remove
